import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  de: {
    translation: {
      loading: 'Laden...',
      deploy_notice: 'Die Software wird aktualisiert. Es kann zu einer kurzen Unterbrechung kommen.',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      close: 'Schliessen',
      login: 'Anmelden',
      logout: 'Abmelden',
      email: 'E-Mail',
      verify: 'Verifizieren',
      role_ultraadmin: 'Ultraadmin',
      role_superadmin: 'Superadmin',
      role_admin: 'Admin',
      role_hr: 'HR',
      role_teacher: 'Lehrperson',
      substitution: 'Vertretung',
      request_substitution: 'Vertretung anfragen',
      status_open: 'Offen',
      status_confirmed: 'Bestätigt',
      status_declined: 'Abgelehnt',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
      // Login page
      login_title: 'Anmeldung',
      login_subtitle: 'Passwordloses Login',
      login_or_email: 'oder per E-Mail',
      email_placeholder: 'E-Mail-Adresse',
      login_send_link: 'Login-Link senden',
      login_sending: 'Wird gesendet...',
      login_security_note: 'Aus Sicherheitsgründen ist die Anzahl Login-Anfragen beschränkt.',
      login_success_title: 'Anmeldung',
      login_success_sent: '✓ Verifizierungs-E-Mail wurde gesendet',
      login_success_text: 'Bitte überprüfen Sie Ihr Postfach und klicken Sie auf den Login-Link.',
      login_success_valid: 'Der Link ist {{minutes}} Minuten gültig',
      login_success_once: 'Der Link kann nur einmal verwendet werden',
      login_spam_tip: 'Tipp: Überprüfen Sie auch Ihren Spam-Ordner, falls Sie die E-Mail nicht sehen.',
      login_resend_in: 'Neuer Link anfordern in {{seconds}}s',
      login_back: '← Zurück zur Eingabe',
      login_success_text_pwa: 'Prüfen Sie Ihr Postfach. Geben Sie den 6-stelligen Code hier ein. Der Link in der Mail ist für den Browser.',
      login_code_label: 'Code aus der E-Mail',
      login_faceid_button: 'Mit Face ID anmelden',
      login_faceid_missing: 'Kein Face ID auf diesem Gerät — E-Mail-Code verwenden.',
      login_faceid_failed: 'Face ID Anmeldung fehlgeschlagen. Bitte E-Mail-Code verwenden.',
      login_faceid_prompt_title: 'Dieses iPhone merken',
      login_faceid_prompt_text: 'Beim nächsten Mal mit Face ID anmelden, ohne neuen Login-Link.',
      login_faceid_remember: 'Merken',
      login_faceid_later: 'Jetzt nicht',
      login_faceid_saving: 'Wird gespeichert...',
      login_faceid_enroll_error: 'Face ID konnte nicht eingerichtet werden.',
      login_passkey_button: 'Mit Fingerabdruck anmelden',
      login_passkey_missing: 'Kein Passkey auf diesem Gerät — E-Mail-Login verwenden.',
      login_passkey_failed: 'Passkey-Anmeldung fehlgeschlagen. Bitte E-Mail-Login verwenden.',
      login_passkey_prompt_title: 'Dieses Gerät merken',
      login_passkey_prompt_text: 'Beim nächsten Mal mit Fingerabdruck anmelden, ohne neuen Login-Link.',
      login_passkey_enroll_error: 'Passkey konnte nicht eingerichtet werden.',
      // Timetable Import - PDF Viewer
      pdfViewer_title: 'PDF-Seite anzeigen',
      pdfViewer_zoomIn: 'Vergrössern',
      pdfViewer_zoomOut: 'Verkleinern',
      pdfViewer_resetZoom: '100%',
      pdfViewer_fitWidth: 'An Breite anpassen',
      pdfViewer_page: 'Seite {{current}} von {{total}}',
      pdfViewer_singlePage: 'Seite {{current}}',
      pdfViewer_loading: 'Laden...',
      pdfViewer_loadError: 'PDF konnte nicht geladen werden',
      pdfViewer_close: 'Schliessen',
      pdfViewer_fileNotFound: 'PDF nicht gefunden',
      pdfViewer_corruptPdf: 'PDF ist beschädigt',
      pdfViewer_permissionDenied: 'Keine Berechtigung',
      pdfViewer_networkError: 'Verbindungsfehler',
      pdfViewer_retry: 'Erneut versuchen',
      // Unmatched Subject Dialog
      unmatchedSubjectDialog_title: 'Unbekanntes Fach: {{token}}',
      unmatchedSubjectDialog_tabAlias: 'Alias zuordnen',
      unmatchedSubjectDialog_tabNew: 'Neues Fach erstellen',
      unmatchedSubjectDialog_aliasDescription: 'Ordnen Sie "{{token}}" einem bestehenden Fach als Alias zu.',
      unmatchedSubjectDialog_loading: 'Vorschläge laden...',
      unmatchedSubjectDialog_selectSubject: 'Fach auswählen',
      unmatchedSubjectDialog_noSuggestions: 'Keine Vorschläge gefunden',
      unmatchedSubjectDialog_cancel: 'Abbrechen',
      unmatchedSubjectDialog_createAlias: 'Als Alias zuordnen',
      unmatchedSubjectDialog_noMatch: 'Kein passendes Fach? Neues Fach erstellen',
      unmatchedSubjectDialog_subjectName: 'Fach-Name',
      unmatchedSubjectDialog_subjectNamePlaceholder: 'Fach-Name eingeben',
      unmatchedSubjectDialog_subjectCode: 'Fach-Code (optional)',
      unmatchedSubjectDialog_subjectCodePlaceholder: '',
      unmatchedSubjectDialog_selectBackground: 'Hintergrund auswählen',
      unmatchedSubjectDialog_createNewBackground: 'Neuen Hintergrund erstellen',
      unmatchedSubjectDialog_backgroundName: 'Hintergrund-Name',
      unmatchedSubjectDialog_backgroundNamePlaceholder: '',
      unmatchedSubjectDialog_backgroundCode: 'Hintergrund-Code (optional)',
      unmatchedSubjectDialog_backgroundCodePlaceholder: '',
      unmatchedSubjectDialog_qualificationLevel: 'Gruppennummer',
      unmatchedSubjectDialog_create: 'Neues Fach anlegen',
      // Qualification Levels (legacy, kept for backward compatibility)
      qualificationLevel_primary: 'Primär',
      qualificationLevel_qualified: 'Qualifiziert',
      qualificationLevel_partial: 'Teilqualifiziert',
      // Token Resolution Notifications
      tokenResolution_aliasExists: 'Alias existiert bereits',
      tokenResolution_entityNotFound: 'Entität nicht gefunden',
      tokenResolution_connectionError: 'Verbindungsfehler',
      tokenResolution_autoResolved: 'Token "{{token}}" automatisch via Alias aufgelöst',
      // Bulk Import
      bulkImport_title: 'Bulk-Import',
      bulkImport_fileInfo: 'Datei: {{filename}} ({{pageCount}} Seiten)',
      bulkImport_templateSelection: 'Vorlage auswählen',
      bulkImport_noTemplates: 'Keine Vorlagen verfügbar — Import ohne Vorlage',
      bulkImport_singleTemplate: 'Verwende Vorlage: {{name}}',
      bulkImport_startImport: 'Bulk-Import starten',
      bulkImport_progress_title: 'Import läuft',
      bulkImport_progress_cancel: 'Abbrechen',
      bulkImport_progress_processing: 'Verarbeite Seite {{current}} von {{total}}',
      bulkImport_progress_paused: 'Angehalten für Token-Auflösung',
      bulkImport_progress_completed: 'Import abgeschlossen',
      bulkImport_progress_failed: 'Import fehlgeschlagen',
      bulkImport_resolution_title: 'Token-Auflösung erforderlich',
      bulkImport_resolution_resume: 'Auflösen und fortsetzen',
      bulkImport_resolution_skip: 'Seite überspringen',
      bulkImport_resolution_importAll: 'Alle aufgelösten importieren',
      bulkImport_result_title: 'Import abgeschlossen',
      bulkImport_result_summary: '{{resolved}} von {{total}} Seiten erfolgreich importiert',
      bulkImport_result_viewTimetables: 'Stundenpläne anzeigen',
      bulkImport_result_close: 'Schliessen',
      // Bulk Import Error Handling
      bulkImport_resumeFailed: 'Import fortsetzen fehlgeschlagen',
      bulkImport_batchFailed: 'Import fehlgeschlagen',
      bulkImport_unexpectedStatus: 'Unerwarteter Batch-Status',
      bulkImport_statusFetchingFailed: 'Batch-Status konnte nicht geladen werden',
      bulkImport_noPendingSections: 'Keine weiteren Seiten zur Auflösung gefunden',
      bulkImport_continuing: 'Import läuft weiter...',
      bulkImport_errorsFound: '{{count}} Fehler gefunden',
      bulkImport_failedPages: 'Fehlgeschlagene Seiten',
      bulkImport_incompletePages: 'Unvollständige Seiten',
      bulkImport_resolutionRequired: 'Auflösung erforderlich',
      bulkImport_resolve: 'Auflösen',
      bulkImport_importAll: 'Alle importieren',
      bulkImport_pageError: 'Seite {{page}}: {{error}}',
      bulkImport_resolutionNeeded: 'Auflösung nötig',
      bulkImport_moreErrors: '+{{count}} weitere...',
      bulkImport_successful: 'Erfolgreich',
      bulkImport_withErrors: 'Mit Fehlern',
      bulkImport_skipped: 'übersprungen',
      bulkImport_preview: 'Vorschau',
      bulkImport_previewEntries: 'Einträge anzeigen',
      files_fallback_failed: 'Import fehlgeschlagen',
      files_fallback_retry: 'Erneut versuchen',
      files_fallback_download: 'PDF herunterladen',
      talk_hold: 'Halten zum Sprechen',
      talk_hold_short: 'Halten',
      talk_linking: 'Verbindung wird aufgebaut',
      talk_confirm_out: '{{when}}. {{count}} Lektionen gehen als eine Anfrage raus.',
      talk_col_time: 'Zeit',
      talk_col_subject: 'Fach',
      talk_col_class: 'Klasse',
      talk_send: 'Senden',
      talk_discard: 'Verwerfen',
      talk_ask_span: 'Zeitspanne',
      talk_ask_span_hint: 'Mehrere Tage als ein Block, keine Tagesliste',
      talk_ask_span_body: '{{range}}. {{count}} Tage, eine Tür. Keine Liste.',
      talk_ask_days: 'Einzelne Tage',
      talk_ask_days_hint: 'Danach die Tage, nicht vorher',
      talk_ask_days_step: 'Tage',
      talk_ask_days_pick: 'Mehrere Tage, Lücken erlaubt, dann abschicken.',
      talk_ask_what: 'Was gilt?',
      talk_ask_submit: 'Abschicken',
      talk_ask_abort: 'Abbrechen',
      talk_ask_back: 'Zurück',
      talk_ask_day_count: '{{count}} Tage',
      talk_ask_lessons: '{{count}} Lektionen',
      talk_empty: 'Keine Anliegen',
      talk_transcript_pending: 'Transkript folgt',
      talk_transcript_retry: 'Erneut versuchen',
      talk_transcript_retry_fail: 'Transkription fehlgeschlagen',
      talk_waiting_net: 'Wartet auf Netz',
      talk_in_progress: 'In Arbeit',
      talk_followup: 'Rückfrage',
      talk_ask_whole_door: 'Ganzer Tag',
      talk_ask_lesson_door: 'Einzelne Lektionen',
      talk_ask_lessons_step: 'Lektionen',
      talk_ask_lessons_hint: 'Danach die Liste, nicht vorher',
      talk_ask_all: '{{span}}, alle {{count}} Lektionen',
      talk_ask_other_door: 'Andere Tür',
      talk_ask_whole_line: '{{when}}{{count}} Lektionen. Keine Liste.',
      talk_ask_pick: 'Mehrere, dann abschicken.',
      talk_confirm_status: 'Bitte bestätigen',
      talk_confirm_spoken: 'wird gesprochen',
      talk_in_flight: 'Unterwegs',
      talk_clip_sent: '{{time}} · gesendet',
      talk_done: 'Erledigt',
      talk_mic_denied: 'Mikrofon gesperrt. Tippen ist weiterhin möglich.',
      talk_mic_insecure: 'Mikrofon braucht HTTPS. Tastatur unten rechts bleibt.',
      talk_delete_confirm: 'Dieses Anliegen bei dir löschen?',
      talk_push_nag: 'Bitte Benachrichtigungen erlauben, sonst verpasst du Rückfragen.',
      talk_push_allow: 'Erlauben',
      talk_keyboard_placeholder: 'Nachricht an Support…',
      talk_inbox: 'Inbox',
      talk_overview: 'Übersicht',
      talk_radar: 'Radar',
      talk_radar_rings: 'Ringe',
      talk_radar_sweep: 'Sweep',
      talk_radar_panic: 'Panik',
      talk_radar_middle: 'Mittel',
      talk_radar_outer: 'Aussen',
      talk_radar_code_collapse: '{{code}} einklappen, {{count}} Bubbles',
      talk_radar_code_expand: '{{code}} aufklappen, {{count}} Bubbles',
      talk_radar_pick: '{{count}} Anfragen',
      talk_radar_message: 'Nachricht',
      talk_radar_send: 'Senden',
      talk_radar_message_failed: 'Nachricht senden fehlgeschlagen',
      talk_radar_no_lessons: 'Keine Lektionen ausgewählt.',
      talk_radar_no_recipients: 'Keine Empfänger ausgewählt.',
      talk_radar_lessons: 'Lektionen',
      talk_radar_all_lessons: 'Alle Lektionen ({{count}})',
      talk_radar_recipients: 'Empfänger',
      talk_radar_declined: 'Abgelehnte ({{count}})',
      talk_radar_pending: 'Ausstehende ({{count}})',
      talk_radar_assign: 'Zuweisen',
      talk_radar_change: 'Ändern',
      talk_radar_teacher: 'Lehrperson',
      talk_radar_assign_failed: 'Zuweisung fehlgeschlagen',
      talk_radar_overwrite: 'Lektion ist bereits zugewiesen an {{name}}. Überschreiben?',
      talk_radar_overwrite_action: 'Überschreiben',
      talk_radar_cancel: 'Abbrechen',
      talk_radar_storno: 'Stornieren',
      talk_radar_remove: 'Entfernen',
      talk_radar_storno_request: 'Anfrage stornieren',
      talk_radar_storno_request_short: 'Anfrage',
      talk_radar_actions: 'Aktionen',
      talk_radar_remind: 'Erinnerung',
      talk_radar_remind_ask: 'Erinnerung senden?',
      talk_radar_remind_placeholder: 'Optionale Nachricht (sonst Standardtext)...',
      talk_radar_confirm: 'Bestätigen',
      talk_radar_storno_lesson_ask: 'Lektion stornieren?',
      talk_radar_last_live: 'Dies ist die letzte lebende Lektion. Die ganze Anfrage fällt.',
      talk_radar_storno_request_ask: 'Anfrage wirklich stornieren? Alle offenen Antworten werden abgelehnt.',
      talk_radar_status_pending: 'Offen',
      talk_radar_status_accepted: 'Akzeptiert',
      talk_radar_status_declined: 'Abgelehnt',
      talk_radar_status_cancelled: 'Storniert',
      talk_radar_status_booked: 'Gebucht',
      talk_radar_status_partially_filled: 'Teilweise',
      talk_radar_status_interested: 'Interessiert',
      talk_radar_status_filled: 'Besetzt',
      talk_radar_status_assigned_elsewhere: 'Von anderer übernommen',
      talk_radar_status_expired: 'Abgelaufen',
      talk_radar_status_director_pending: 'Direktor-Freigabe ausstehend',
      talk_radar_status_director_returned: 'Zurückgestellt (angepasst)',
      talk_radar_hr_lesson: 'Diese Lektion würde an das HR für die Vergütung gehen.',
      talk_radar_hr_request: 'Diese Anfrage enthält Lektionen die an das HR für die Vergütung gehen würden.',
      talk_radar_docs_due: 'Dokumente ausstehend',
      talk_radar_distribution: 'Verteilung läuft · Suche in {{eta}}',
      talk_radar_payer_school: 'Schule zahlt',
      talk_radar_payer_private: 'Privat zahlt',
      talk_radar_director: 'Direktor: {{decision}}',
      talk_radar_col_date: 'Datum',
      talk_radar_col_time: 'Zeit',
      talk_radar_col_subject: 'Fach',
      talk_radar_col_class: 'Klasse',
      talk_radar_col_action: 'Aktion',
      talk_radar_col_substitute: 'Vertretung',
      talk_radar_word_removed: 'Entfernt',
      talk_radar_word_lost: 'Verloren',
      talk_radar_word_taken: 'Belegt',
      talk_radar_word_definite: 'Definitiv',
      talk_radar_word_accepted: 'Angenommen',
      talk_radar_word_waiting: 'Wartepool',
      talk_radar_word_open: 'Offen',
      talk_radar_banner_cancelled: 'STORNIERT',
      talk_radar_no_substitute: 'Keine Vertretung',
      talk_radar_participants: 'Beteiligte',
      talk_radar_requesting: 'Anfragend',
      talk_radar_initials: 'Initialen {{name}}',
      talk_radar_nobody_assigned: 'Niemand zugewiesen',
      talk_radar_pay: 'Vergütung',
      talk_radar_payout: 'Auszahlung',
      talk_radar_deduction: 'Abzug',
      talk_radar_salary: 'Lohnabzug',
      talk_radar_no_prep: 'Kein Prep',
      talk_radar_prep_asked: 'angefragt',
      talk_radar_prep_count: '{{done}}/{{total}} Prep',
      talk_radar_prep_ask: 'Prep anfordern',
      talk_radar_prep_open: 'Prep öffnen',
      talk_radar_prep_done: 'Prep erledigt',
      talk_radar_day_decline: 'Ablehnen',
      talk_radar_day_decline_ask: 'Diesen Tag ablehnen?',
      talk_radar_days_open: 'Nicht angekreuzte Tage bleiben offen.',
      talk_radar_days_take: 'Übernehmen',
      talk_radar_days_take_ask: 'Die angehakten Tage übernehmen?',
      talk_radar_withdraw: 'Zurückziehen',
      talk_radar_full_day: 'Ganztag',
      talk_radar_partial: 'Brocken',
      talk_play: 'Abspielen',
      talk_support: 'Support',
      talk_ticket: 'Anliegen',
      talk_language: 'Sprache',
      talk_speaker: 'Lautsprecher',
      talk_role_now_sub: 'Aktive Rolle',
      help_title: 'Hilfe',
      help_open: 'Offen',
      help_done: 'Erledigt',
      help_search_name: 'Name suchen…',
      help_load_more: 'Weitere laden',
      help_pick_entry: 'Eintrag auswählen',
      help_reply_as_support: 'Als Support antworten…',
      help_load_error: 'Hilfe konnte nicht geladen werden.',
      help_loading: 'Laden…',
      help_empty_inbox: 'Keine Einträge.',
      help_person: 'Person',
      help_role: 'Rolle',
      help_school: 'Schule',
      help_waiting: 'Wartet',
      help_status: 'Status',
      help_answers: 'Antworten',
      help_load_older: 'Ältere laden',
    }
  },
  en: {
    translation: {
      talk_hold: 'Hold to speak',
      talk_hold_short: 'Hold',
      talk_linking: 'Connecting',
      talk_confirm_out: '{{when}}. {{count}} lessons go out as one request.',
      talk_col_time: 'Time',
      talk_col_subject: 'Subject',
      talk_col_class: 'Class',
      talk_send: 'Send',
      talk_discard: 'Discard',
      talk_ask_span: 'Span',
      talk_ask_span_hint: 'Several days as one block, no day list',
      talk_ask_span_body: '{{range}}. {{count}} days, one door. No list.',
      talk_ask_days: 'Single days',
      talk_ask_days_hint: 'The days come after, not before',
      talk_ask_days_step: 'Days',
      talk_ask_days_pick: 'Several days, gaps allowed, then submit.',
      talk_ask_what: 'What applies?',
      talk_ask_submit: 'Submit',
      talk_ask_abort: 'Abort',
      talk_ask_back: 'Back',
      talk_ask_day_count: '{{count}} days',
      talk_ask_lessons: '{{count}} lessons',
      talk_empty: 'No requests',
      talk_transcript_pending: 'Transcript pending',
      talk_transcript_retry: 'Retry',
      talk_transcript_retry_fail: 'Transcription failed',
      talk_waiting_net: 'Waiting for network',
      talk_in_progress: 'In progress',
      talk_followup: 'Follow-up',
      talk_ask_whole_door: 'Whole day',
      talk_ask_lesson_door: 'Single lessons',
      talk_ask_lessons_step: 'Lessons',
      talk_ask_lessons_hint: 'The list comes after, not before',
      talk_ask_all: '{{span}}, all {{count}} lessons',
      talk_ask_other_door: 'Other door',
      talk_ask_whole_line: '{{when}}{{count}} lessons. No list.',
      talk_ask_pick: 'Several, then submit.',
      talk_confirm_status: 'Please confirm',
      talk_confirm_spoken: 'will be spoken',
      talk_in_flight: 'On the way',
      talk_clip_sent: '{{time}} · sent',
      talk_done: 'Done',
      talk_mic_denied: 'Microphone blocked. Typing still works.',
      talk_mic_insecure: 'Microphone needs HTTPS. Keyboard at bottom right still works.',
      talk_delete_confirm: 'Delete this request on this device?',
      talk_push_nag: 'Allow notifications so you do not miss follow-ups.',
      talk_push_allow: 'Allow',
      talk_keyboard_placeholder: 'Message to support…',
      talk_inbox: 'Inbox',
      talk_overview: 'Overview',
      talk_radar: 'Radar',
      talk_radar_rings: 'Rings',
      talk_radar_sweep: 'Sweep',
      talk_radar_panic: 'Panic',
      talk_radar_middle: 'Middle',
      talk_radar_outer: 'Outer',
      talk_radar_code_collapse: 'Collapse {{code}}, {{count}} bubbles',
      talk_radar_code_expand: 'Expand {{code}}, {{count}} bubbles',
      talk_radar_pick: '{{count}} requests',
      talk_radar_message: 'Message',
      talk_radar_send: 'Send',
      talk_radar_message_failed: 'Failed to send message',
      talk_radar_no_lessons: 'No lessons selected.',
      talk_radar_no_recipients: 'No recipients selected.',
      talk_radar_lessons: 'Lessons',
      talk_radar_all_lessons: 'All lessons ({{count}})',
      talk_radar_recipients: 'Recipients',
      talk_radar_declined: 'Declined ({{count}})',
      talk_radar_pending: 'Pending ({{count}})',
      talk_radar_assign: 'Assign',
      talk_radar_change: 'Change',
      talk_radar_teacher: 'Teacher',
      talk_radar_assign_failed: 'Assignment failed',
      talk_radar_overwrite: 'Lesson is already assigned to {{name}}. Overwrite?',
      talk_radar_overwrite_action: 'Overwrite',
      talk_radar_cancel: 'Cancel',
      talk_radar_storno: 'Cancel lesson',
      talk_radar_remove: 'Remove',
      talk_radar_storno_request: 'Cancel request',
      talk_radar_storno_request_short: 'Request',
      talk_radar_actions: 'Actions',
      talk_radar_remind: 'Reminder',
      talk_radar_remind_ask: 'Send a reminder?',
      talk_radar_remind_placeholder: 'Optional message (otherwise default text)...',
      talk_radar_confirm: 'Confirm',
      talk_radar_storno_lesson_ask: 'Cancel this lesson?',
      talk_radar_last_live: 'This is the last live lesson. The whole request falls.',
      talk_radar_storno_request_ask: 'Really cancel the request? All open responses will be declined.',
      talk_radar_status_pending: 'Open',
      talk_radar_status_accepted: 'Accepted',
      talk_radar_status_declined: 'Declined',
      talk_radar_status_cancelled: 'Cancelled',
      talk_radar_status_booked: 'Booked',
      talk_radar_status_partially_filled: 'Partial',
      talk_radar_status_interested: 'Interested',
      talk_radar_status_filled: 'Filled',
      talk_radar_status_assigned_elsewhere: 'Taken over by someone else',
      talk_radar_status_expired: 'Expired',
      talk_radar_status_director_pending: 'Awaiting director approval',
      talk_radar_status_director_returned: 'Returned (adjusted)',
      talk_radar_hr_lesson: 'This lesson would go to HR for payment.',
      talk_radar_hr_request: 'This request has lessons that would go to HR for payment.',
      talk_radar_docs_due: 'Documents outstanding',
      talk_radar_distribution: 'Distribution running · search in {{eta}}',
      talk_radar_payer_school: 'School pays',
      talk_radar_payer_private: 'Private pays',
      talk_radar_director: 'Director: {{decision}}',
      talk_radar_col_date: 'Date',
      talk_radar_col_time: 'Time',
      talk_radar_col_subject: 'Subject',
      talk_radar_col_class: 'Class',
      talk_radar_col_action: 'Action',
      talk_radar_col_substitute: 'Substitute',
      talk_radar_word_removed: 'Removed',
      talk_radar_word_lost: 'Lost',
      talk_radar_word_taken: 'Taken',
      talk_radar_word_definite: 'Definite',
      talk_radar_word_accepted: 'Accepted',
      talk_radar_word_waiting: 'Waiting pool',
      talk_radar_word_open: 'Open',
      talk_radar_banner_cancelled: 'CANCELLED',
      talk_radar_no_substitute: 'No substitute',
      talk_radar_participants: 'Participants',
      talk_radar_requesting: 'Requesting',
      talk_radar_initials: 'Initials {{name}}',
      talk_radar_nobody_assigned: 'Nobody assigned',
      talk_radar_pay: 'Pay',
      talk_radar_payout: 'Payout',
      talk_radar_deduction: 'Deduction',
      talk_radar_salary: 'Salary deduction',
      talk_radar_no_prep: 'No prep',
      talk_radar_prep_asked: 'Requested',
      talk_radar_prep_count: '{{done}}/{{total}} Prep',
      talk_radar_prep_ask: 'Request prep',
      talk_radar_prep_open: 'Open prep',
      talk_radar_prep_done: 'Prep done',
      talk_radar_day_decline: 'Decline',
      talk_radar_day_decline_ask: 'Decline this day?',
      talk_radar_days_open: 'Unticked days stay open.',
      talk_radar_days_take: 'Take',
      talk_radar_days_take_ask: 'Take the ticked days?',
      talk_radar_withdraw: 'Withdraw',
      talk_radar_full_day: 'Full day',
      talk_radar_partial: 'Partial',
      talk_play: 'Play',
      talk_support: 'Support',
      talk_ticket: 'Request',
      talk_language: 'Language',
      talk_speaker: 'Speaker',
      talk_role_now_sub: 'Active role',
      help_title: 'Help',
      help_open: 'Open',
      help_done: 'Done',
      help_search_name: 'Search name…',
      help_load_more: 'Load more',
      help_pick_entry: 'Select an entry',
      help_reply_as_support: 'Reply as support…',
      help_load_error: 'Help could not be loaded.',
      help_loading: 'Loading…',
      help_empty_inbox: 'No entries.',
      help_person: 'Person',
      help_role: 'Role',
      help_school: 'School',
      help_waiting: 'Waiting',
      help_status: 'Status',
      help_answers: 'Reply',
      help_load_older: 'Load older',
    }
  },
  'de-CH': {
    translation: {
      // Swiss German spelling: ß -> ss
      zones_outer: 'Aussenzone',
      outerZone: 'Aussenzone',
    }
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de',
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
